/* eslint-disable react-refresh/only-export-components */
import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';
import { createContext, useMemo, useState } from 'react';

import type { BreadCrumbDetails } from '@shared/components';

export interface IGlobalBreadcrumbs {
  portal?: {
    className?: string;
    data?: BreadCrumbDetails[];
    isIncludedEservices?: boolean;
  };
}

export const GlobalBreadcrumbsContext = createContext<null | {
  globalBreadcrumbs?: IGlobalBreadcrumbs;
  setGlobalBreadcrumbs: Dispatch<SetStateAction<IGlobalBreadcrumbs | undefined>>;
}>(null);

const GlobalBreadcrumbsContextWrapper = ({ children }: PropsWithChildren) => {
  const [globalBreadcrumbs, setGlobalBreadcrumbs] = useState<IGlobalBreadcrumbs>();

  const value = useMemo(
    () => ({
      globalBreadcrumbs,
      setGlobalBreadcrumbs,
    }),
    [globalBreadcrumbs]
  );

  return <GlobalBreadcrumbsContext.Provider value={value}>{children}</GlobalBreadcrumbsContext.Provider>;
};

export default GlobalBreadcrumbsContextWrapper;
